export default __webpack_public_path__ + "static/media/download.381ab218.svg";